import React from 'react';
type PageHeaderProps = {
  eyebrow: string;
  title: string;
  description: string;
};
export function PageHeader({
  eyebrow,
  title,
  description
}: PageHeaderProps) {
  return <section className="relative w-full overflow-hidden border-b border-navy-100 bg-brand-indigo/[0.035]" data-id="element-92" data-mp="3relvx5pfiql2">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 -top-32 h-80 w-80 rounded-full bg-brand-violet/10 blur-3xl" data-id="element-93" data-mp="3mfskditpd9nj" />
      <div className="relative mx-auto max-w-content px-6 py-16 sm:py-20" data-id="element-94" data-mp="2yq82725digfb">
        <p className="inline-flex items-center rounded-full border border-brand-indigo/20 bg-white px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-brand-indigo" data-id="element-95" data-mp="2ts6e22t3bqwz">
          {eyebrow}
        </p>
        <h1 className="mt-5 max-w-3xl text-4xl font-bold leading-tight tracking-tight text-navy-800 sm:text-5xl" data-id="element-96" data-mp="33nq9ko3qsnl7">
          {title}
        </h1>
        <span aria-hidden="true" className="mt-6 block h-1 w-20 rounded-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-97" data-mp="2b0m3sgwts58d" />
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-navy-500" data-id="element-98" data-mp="2hx5gsjexgj5g">
          {description}
        </p>
      </div>
    </section>;
}